// 数字
export function validateNumber(val) {
    console.log(val)
    let number = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
    return number.test(val)
}